import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { dataNotFoundMsg, noInternetMsg, saveFailedMsg, savemsg, saveWarningMsg, serverMsg } from "../../config/messageconstant";
import { mandatoryCheck } from "../../config/ValidationCheck";
import { EncashedLeaveProcessJson } from "../../DynamicFormsJson/Transaction/encashedLeaveProcess";
import {
    getLeaveTypeBySalesTeamAndLeaveYearForEncashed,
    getLeaveYearBySalesTeamIdForEncashed,
} from "../../Slice/year.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import EncashedLeaveAssignationProcessTable from "./EncashedLeaveAssignationProcessTable";

class EncashedLeaveAssignationProcess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                leaveYearMasterDetail: this.props.leaveYearList?.encashedLeave,
            },
            formErrors: {},
            fieldData: {},
            salesTeamDataList: [],
            formErrorForDetails: {},
        }
    }

    async componentDidMount() {
        const { getLeaveYearBySalesTeamIdForEncashed, showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            this.setState({ salesTeamDataList: [] });

            let salesTeamIdForCarryForward = this.props.params.id;

            showLoador({ loador: true });
            await getLeaveYearBySalesTeamIdForEncashed({ salesTeamId: salesTeamIdForCarryForward }).then(({ response, success }) => {
                if (!success) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                }
            });
            showLoador({ loador: false });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }


    componentWillReceiveProps(nextProps) {
        if (
            this.props.leaveYearList.encashedLeave !==
            nextProps.leaveYearList.encashedLeave
        ) {
            this.setState({
                dynamicMasterData: {
                    ...this.state.dynamicMasterData,
                    leaveYearMasterDetail: nextProps.leaveYearList.encashedLeave,
                },
            });
        }
    }

    getListById = async (data) => {
        const {
            getLeaveTypeBySalesTeamAndLeaveYearForEncashed,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {

            let salesTeamIdForCarryForward = this.props.params.id;
            if (data.leaveYearId && data.leaveYearId != "") {
                showLoador({ loador: true });
                await getLeaveTypeBySalesTeamAndLeaveYearForEncashed({
                    salesTeamId: salesTeamIdForCarryForward,
                    leaveYearId: data.leaveYearId
                }).then(({ response, success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                        if (Object.keys(response).length !== 0) {
                            if (response?.leaveTypes.length == 0) {
                                return showNotification({ msg: dataNotFoundMsg, severity: "error" });

                            }
                            this.setState({ salesTeamDataList: response?.leaveTypes || [] });
                        }
                    }
                }
                );
                showLoador({ loador: false });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    checkValidationOnSubmitForDetails = () => {
        const { salesTeamDataList } = this.state;
        let formErrorForDetails = {};
        let formIsValid = true;
        let errorMessage = "This field is required";

        salesTeamDataList.map((item) => {
            if (item.encashedLeave === "" || item.encashedLeave === null || item.encashedLeave === undefined) {
                formIsValid = false;
                formErrorForDetails[`encashedLeaveError${item.id}`] = errorMessage;
            }
        });

        this.setState({ formErrorForDetails });
        return formIsValid;
    };


    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: EncashedLeaveProcessJson.fieldMeta,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        return mandatoryCheckErrors.formValid;
    };

    submithandler = () => {
        const { fieldData, salesTeamDataList } = this.state;

        let salesTeamIdForCarryForward = this.props.params.id;

        let encashedLeaveDetails = salesTeamDataList.map((dataObj) => {
            return {
                leaveType: { id: dataObj.id },
                encashedLeaves: dataObj.encashedLeave,
            }
        });

        let dataToSave = {
            salesTeam: { id: salesTeamIdForCarryForward },
            leaveYear: { id: fieldData.leaveYearId },
            encashedLeaveDetails: encashedLeaveDetails
        }

        if (this.checkValidationOnSubmit() && this.checkValidationOnSubmitForDetails()) {
            this.onSave(dataToSave);
        }
    }

    onSave = (dataToSave) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            swal({
                title: "Are you sure?",
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url: endpoint.encashedLeaveHeader,
                        postBody: dataToSave,
                    }).then(({ data, success }) => {
                        if (success) {
                            this.props.navigate(-1);
                            showNotification({ msg: savemsg });
                        } else {
                            showNotification({ msg: saveFailedMsg, severity: "error" });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;

        if (fieldName === "leaveYearId") {
            this.setState({ salesTeamDataList: [] });
        }
        EncashedLeaveProcessJson.fieldMeta.map((currentField) => {
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");

                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });

                this.getListById(dataToSearch);
            }
            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };


    onChangeTextField = (e, id) => {
        const { salesTeamDataList } = this.state;
        const { name, value } = e.target;

        const updatedList = salesTeamDataList.map((item) => {
            if (item.id == id) {
                let validatedValue = value;

                const numericValue = parseFloat(value) || 0;
                const balance = parseFloat(item.balance) || 0;

                if (numericValue > balance) {
                    validatedValue = balance;
                }
                if (numericValue < 0) {
                    validatedValue = 0;
                }
                return { ...item, [name]: validatedValue };
            }
            return item;
        });

        this.setState({ salesTeamDataList: updatedList });
    };

    render() {
        const {
            fieldData,
            formErrors,
            dynamicMasterData,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        getListById={this.getListById}
                        showTitle={EncashedLeaveProcessJson.showTitle}
                        screenTitle={"Encashed Leave Assignation"}
                        fieldMeta={EncashedLeaveProcessJson.fieldMeta}
                        apiBaseURL={EncashedLeaveProcessJson.apiBaseURL}
                        formErrors={formErrors}
                        showSaveBtn={EncashedLeaveProcessJson.showSaveBtn}
                        showSaveBtnMain={false}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        showBackToList={true}
                    />

                    <EncashedLeaveAssignationProcessTable
                        clickSubmitHandler={this.submithandler}
                        salesTeamDataList={this.state.salesTeamDataList}
                        onChangeTextField={this.onChangeTextField}
                        formErrorForDetails={this.state.formErrorForDetails}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    leaveYearList: state.year,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getLeaveYearBySalesTeamIdForEncashed,
    getLeaveTypeBySalesTeamAndLeaveYearForEncashed,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(EncashedLeaveAssignationProcess);
